import React from 'react';
import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import useScrollReveal from '@/hooks/useScrollReveal';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { tellMeMoreCopy } from '@/contexts/language/translations/pages/tellMeMore';

const TellMeMore = () => {
  useScrollReveal();
  const { language } = useLanguage();
  const c = tellMeMoreCopy[language];

  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title={c.seoTitle}
        description={c.seoDescription}
        canonical="/tell-me-more"
      />
      <Navigation />
      <main className="index-page flex-1">

        {/* Hero */}
        <section className="relative pt-28 pb-16 md:pt-36 md:pb-20 overflow-hidden bg-white">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#FFF7EC] rounded-full filter blur-3xl opacity-60" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#E0E7FF] rounded-full filter blur-3xl opacity-40" />

          <div className="container-custom relative z-10 reveal">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#2A1E47] mb-6 leading-[1.08]">
                {c.title}
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
                {c.subtitle}
              </p>
            </div>
          </div>
        </section>

        {/* Form + calendar */}
        <section className="pb-20 md:pb-28 px-7 md:px-10">
          <div className="container-custom reveal">
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-start">
              <ContactForm service="Tell Me More" className="mx-0" />

              {/* Calendar booking */}
              <div className="rounded-2xl border border-gray-100 bg-[#FAFAFA] p-8 md:p-10 flex flex-col items-center justify-center text-center min-h-[420px]">
                <svg className="w-10 h-10 text-[#FF6B35] mb-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                </svg>
                <h3 className="text-lg font-bold text-[#2A1E47] mb-2">{c.calendarTitle}</h3>
                <p className="text-sm text-muted-foreground max-w-xs mb-6">
                  {c.calendarText}
                </p>
                <a
                  href="https://calendar.app.google/d1zdx9SNCNmx37gz8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#FF6B35] text-white font-medium hover:bg-[#FF6B35]/90 transition-colors"
                >
                  {c.calendarButton}
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default TellMeMore;
